import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: space-around;
  padding: 1em 1em 4em 1em;
  background-color: ${(props) => props.theme.color.neutral.v100};
  text-align: center;
  font-weight: 700;
  font-size: 20px;
`;

const DuoCheckmark = styled.img`
  padding: 2em 0 1em 0;
  width: 50px;
  height: 50px;
`;
const CloseButton = styled(PrimaryButton)`
  padding: 0;

  width: 100%;
  min-height: 56px;
  font-size: 14px;
  margin-top: 40px;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 250px;
    text-align: center;
  }
`;

export { ModalContent, DuoCheckmark, CloseButton };
